import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fallback from "locales/en-x-fallback/translation.json";
import uac from "locales/en-x-UAC/translation.json";
import utas from "locales/en-x-UTAS/translation.json";

i18n.use(initReactI18next).init({
  load: "currentOnly",
  lng: "en-x-fallback",
  fallbackLng: "en-x-fallback",
  supportedLngs: ["en-x-fallback", "en-x-uac", "en-x-utas"],
  debug: false,
  interpolation: {
    escapeValue: false
  },
  resources: {
    "en-x-fallback": {
      translation: fallback
    },
    "en-x-uac": {
      translation: uac
    },
    "en-x-utas": {
      translation: utas
    }
  },
  defaultNS: "translation"
});

export default i18n;
